import dayjs from "dayjs";
import { isInternetExplorer } from "./client";

export function todayInSydney() {
  if (isInternetExplorer()) {
    // IE 11 Does not support toLocaleString with timeZone option. Use best guess option
    const d = new Date();
    d.setHours(d.getUTCHours() + 11);
    return dayjs(d);
  } else {
    return dayjs(new Date().toLocaleString("en-US", { timeZone: "Australia/Sydney" }));
  }
}

export function isBeforeToday(date: dayjs.ConfigType) {
  const today = todayInSydney();
  return dayjs(date).isBefore(today, "day");
}

export function isWeekend(date: dayjs.ConfigType) {
  let mDate = dayjs(date);
  return mDate.day() === 0 || mDate.day() === 6;
}

export function toIsoDate(day: dayjs.ConfigType) {
  if (day === null) {
    return "";
  }

  return dayjs(day).format("YYYY-MM-DD");
}
